import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';

const API = `${consts.API_URL}/centroCusto`;

export const CENTRO_CUSTO_MODO_TELA =
    'CENTRO_CUSTO_MODO_TELA';

export const CENTRO_CUSTO_SET_AGUARDANDO =
    'CENTRO_CUSTO_SET_AGUARDANDO';

export const CENTRO_CUSTO_LISTADO =
    'CENTRO_CUSTO_LISTADO';

const normalizarInteiro = valor => {
    if (
        valor === null ||
        valor === undefined ||
        valor === ''
    ) {
        return null;
    }

    const numero = parseInt(valor, 10);

    return Number.isInteger(numero)
        ? numero
        : null;
};

const normalizarRegistro = registro => ({
    ...registro,

    id_centro_custo_pai:
        normalizarInteiro(
            registro.id_centro_custo_pai
        ),

    codigo:
        registro.codigo &&
        registro.codigo.toString().trim()
            ? registro.codigo.toString().trim()
            : null
});

export function setModoTela(modo, registro = {}) {
    return {
        type: CENTRO_CUSTO_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: CENTRO_CUSTO_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize(
            'centroCustoForm',
            registro
        )
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: CENTRO_CUSTO_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado =
                normalizarRegistro(registro);

            const request = registroNormalizado.id
                ? axios.put(
                    API,
                    registroNormalizado
                )
                : axios.post(
                    API,
                    registroNormalizado
                );

            await request;

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}